export default __webpack_public_path__ + "static/media/Mask of Red Ruin.59109129.jpg";